export const SPECIALTIES = {
  GENERAL_PRACTICE: "general practice",
  ACUPUNCTURE: "acupuncture",
  ANESTHESIA: "anesthesia and analgesia",
  AVIAN: "avian",
  AQUATICS: "aquatics",
  BEHAVIOR: "behavior",
  CARDIOLOGY: "cardiology",
  DENTAL: "dental",
  DERMATOLOGY: "dermatology",
  EMERGENCY: "emergency",
  EXOTICS: "exotics",
  EQUINE: "equine",
  IMMUNOLOGY: "immunology",
  INTERNAL_MEDICINE: "internal medicine",
  NEPHROLOGY: "nephrology and urology",
  NEUROLOGY: "neurology",
  NUTRITION: "nutrition",
  ONCOLOGY: "oncology",
  OPHTHALMOLOGY: "ophthalmology",
  OTHER: "other",
  PALLIATIVE_CARE: "palliative care",
  PREVENTIVE_MEDICINE: "preventive medicine",
  RADIOLOGY: "radiology",
  REHAB: "rehabilitation",
  REPRODUCTION: "theriogenology",
  SURGERY: "surgery",
  TOXICOLOGY: "toxicology",
} as const;